/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2020-07-10 16:27:16
 * @LastEditors: mrh
 * @LastEditTime: 2020-11-23 10:01:01
 */
// import {
//   login,
//   logout,
//   getInfo
// } from '@/api/user'
// import {
//   getToken,
//   setToken,
//   removeToken
// } from '@/utils/auth'
import store from '@/store'
// import router, {
//   resetRouter
// } from '@/router'


const state = {
  // token: getToken(),
  token: '',
  longitude: '',
  latitude: '',
  communityData: {},
  cateId: '',//二级分类id
  communityShopId: '-1',//社区店id
  name: '',//商品名
  modifyOrderState: false,
  isRecommend: false,//是否改变推荐/取消推荐的状态
  recommend: false,//是否点击推荐/取消推荐（用于首shop页面缓存更新）
  memberId: '',//用户id
  states: '',
  ambientType: 0, //0是小程序环境 1是Android环境 2是IOS环境
  areaId: "", //区id
  nickname: "",//用户名称
  phone: "",//用户手机号码
  cityId: "",//城市id
}

const mutations = {
  SET_token: (state, token) => {
    state.token = token;
  },
  SET_longitude: (state, longitude) => {
    state.longitude = longitude;
  },
  SET_latitude: (state, latitude) => {
    state.latitude = latitude;
  },
  SET_communityData: (state, communityData) => {
    state.communityData = communityData;
  },
  SET_cateId: (state, cateId) => {
    state.cateId = cateId;
  },
  SET_communityShopId: (state, communityShopId) => {
    state.communityShopId = communityShopId;
  },
  SET_name: (state, name) => {
    state.name = name;
  },
  SET_modifyOrderState: (state, modifyOrderState) => {
    state.modifyOrderState = modifyOrderState;
  },
  SET_isRecommend: (state, isRecommend) => {
    state.isRecommend = isRecommend;
  },
  SET_recommend: (state, recommend) => {
    state.recommend = recommend;
  },
  SET_memberId: (state, memberId) => {
    state.memberId = memberId;
  },
  SET_states: (state, states) => {
    state.states = states;
  },
  SET_ambientType: (state, ambientType) => {
    state.ambientType = ambientType;
  },
  SET_areaId: (state, areaId) => {
    state.areaId = areaId;
  },
  SET_nickname: (state, nickname) => {
    state.nickname = nickname;
  },
  SET_phone: (state, phone) => {
    state.phone = phone;
  },
  SET_cityId: (state, cityId) => {
    state.cityId = cityId;
  },
};

const actions = {
  // user login
  // login({
  //   commit
  // }, userInfo) {
  //   return new Promise((resolve, reject) => {
  //     login(userInfo).then(res => {
  //       const data = res.content.token
  //       //console.log(res.content.token)
  //       setToken(data)
  //       commit('SET_TOKEN', data)
  //       resolve(res)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },


}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
